import { Suspense } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import { PersistGate } from 'redux-persist/integration/react';

import Loading from 'common/components/loading/loading';
import store, { persistor as persistorv2 } from 'common/store/store';

import AppRootWrapper from './app-root-wrapper';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

import './styles/styles.scss';

const root = document.getElementById('root');

render(
  <Suspense fallback={<Loading />}>
    <Provider store={store}>
      <PersistGate persistor={persistorv2}>
        <AppRootWrapper />
      </PersistGate>
    </Provider>
  </Suspense>,
  root,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
reportWebVitals();
serviceWorker.unregister();
